import { useStore } from "vuex";
import STATUS from "@/constants/status";
export function notificationCompasable() {
  const store = useStore();
  return {
    STATUS,
    store
  };
}
